import { useEffect, useState } from "react";

import styles from "../../styles/menu-desktop.module.scss";

import { Storage } from "../tools/Storage";

export default function GestorLogo() {
  const [theme, setTheme] = useState({});

  useEffect(() => {
    setTheme(Storage.getItem("theme"));
  }, []);

  return (
    <div className={styles.logo}>
      <img
        src="/Logo.png"
        alt="Logo"
        style={{
          maxWidth: "100%",
          objectFit: "contain",
        }}
      />
    </div>
  );
}
